// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Global styles to prevent page scrollbar */
html,
body {
  margin: 0;
  padding: 0;
  height: 100%;
  overflow: hidden;
}

#root {
  height: 100vh;
  overflow: hidden;
}

.App {
  text-align: center;
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
}

.App-header {
  background: rgb(45, 115, 179);
  background: linear-gradient(90deg, rgba(45, 115, 179, 1) 0%, rgba(45, 115, 179, 1) 35%, rgba(4, 76, 143, 1) 100%);
  height: auto;
  min-height: 60px;
  flex-shrink: 0;
}

.App-main {
  display: flex;
  flex: 1 1;
  min-height: 0;
  flex-direction: column;
}

/* Viewers take all space when registration table is collapsed */
.App-main--registration-collapsed .top-section {
  flex: 1 1 auto;
}

.top-section {
  display: flex;
  flex-direction: row;
  flex: 1 1;
  min-height: 0;
}

.dermoscopy-panel {
  background-color: #f0f4f8;
}

.dermoscopy-panel-inner {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  min-height: 0;
}

.dermoscopy-panel-toolbar {
  flex-shrink: 0;
  padding: 6px 8px;
  border-bottom: 1px solid #dbe3ec;
  text-align: left;
}

.coreg-open-button {
  padding: 6px 12px;
  font-size: 0.85rem;
  border: 1px solid #2d73b3;
  border-radius: 4px;
  background: #2d73b3;
  color: #fff;
  cursor: pointer;
}

.coreg-open-button:hover:not(:disabled) {
  background: #1e5a8f;
}

.coreg-open-button:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.macro-coreg-opacity {
  flex-shrink: 0;
  display: grid;
  grid-template-columns: auto 1fr auto;
  gap: 10px;
  align-items: center;
  padding: 6px 10px;
  font-size: 0.85rem;
  border-bottom: 1px solid #dbe3ec;
  background: #f8fafc;
}

.macro-coreg-opacity-label {
  white-space: nowrap;
  color: #374151;
}

.macro-coreg-opacity input[type='range'] {
  width: 100%;
  min-width: 120px;
  accent-color: #2563eb;
}

.macro-coreg-opacity-value {
  min-width: 2.5rem;
  text-align: right;
  font-variant-numeric: tabular-nums;
  color: #374151;
}

.main-content {
  background-color: #ffffff;
}

.navigation-panel {
  background-color: #f8f9fa;
}

.registration-section {
  overflow: hidden;
}

.collapsible-panel.registration-section--nav.collapsible-panel--expanded.collapsible-panel--side {
  flex: 0 0 280px;
  max-width: 300px;
  min-width: 200px;
}

.registration-section--nav .registration-data-grid {
  margin: 0;
  border: none;
  border-radius: 0;
  box-shadow: none;
  padding: 4px;
}

.App-link {
  color: #61dafb;
}

.main-images {
  display: grid;
  grid-template-columns: 2fr 2fr;
}

.hidden {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/styles/App.css"],"names":[],"mappings":"AAAA,4CAA4C;AAC5C;;EAEE,SAAS;EACT,UAAU;EACV,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,iHAAiH;EACjH,YAAY;EACZ,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAW;EACX,aAAa;EACb,sBAAsB;AACxB;;AAEA,gEAAgE;AAChE;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAW;EACX,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,aAAa;AACf;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,oCAAoC;EACpC,SAAS;EACT,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf","sourcesContent":["/* Global styles to prevent page scrollbar */\nhtml,\nbody {\n  margin: 0;\n  padding: 0;\n  height: 100%;\n  overflow: hidden;\n}\n\n#root {\n  height: 100vh;\n  overflow: hidden;\n}\n\n.App {\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  overflow: hidden;\n}\n\n.App-header {\n  background: rgb(45, 115, 179);\n  background: linear-gradient(90deg, rgba(45, 115, 179, 1) 0%, rgba(45, 115, 179, 1) 35%, rgba(4, 76, 143, 1) 100%);\n  height: auto;\n  min-height: 60px;\n  flex-shrink: 0;\n}\n\n.App-main {\n  display: flex;\n  flex: 1 1 0;\n  min-height: 0;\n  flex-direction: column;\n}\n\n/* Viewers take all space when registration table is collapsed */\n.App-main--registration-collapsed .top-section {\n  flex: 1 1 auto;\n}\n\n.top-section {\n  display: flex;\n  flex-direction: row;\n  flex: 1 1 0;\n  min-height: 0;\n}\n\n.dermoscopy-panel {\n  background-color: #f0f4f8;\n}\n\n.dermoscopy-panel-inner {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n}\n\n.dermoscopy-panel-toolbar {\n  flex-shrink: 0;\n  padding: 6px 8px;\n  border-bottom: 1px solid #dbe3ec;\n  text-align: left;\n}\n\n.coreg-open-button {\n  padding: 6px 12px;\n  font-size: 0.85rem;\n  border: 1px solid #2d73b3;\n  border-radius: 4px;\n  background: #2d73b3;\n  color: #fff;\n  cursor: pointer;\n}\n\n.coreg-open-button:hover:not(:disabled) {\n  background: #1e5a8f;\n}\n\n.coreg-open-button:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.macro-coreg-opacity {\n  flex-shrink: 0;\n  display: grid;\n  grid-template-columns: auto 1fr auto;\n  gap: 10px;\n  align-items: center;\n  padding: 6px 10px;\n  font-size: 0.85rem;\n  border-bottom: 1px solid #dbe3ec;\n  background: #f8fafc;\n}\n\n.macro-coreg-opacity-label {\n  white-space: nowrap;\n  color: #374151;\n}\n\n.macro-coreg-opacity input[type='range'] {\n  width: 100%;\n  min-width: 120px;\n  accent-color: #2563eb;\n}\n\n.macro-coreg-opacity-value {\n  min-width: 2.5rem;\n  text-align: right;\n  font-variant-numeric: tabular-nums;\n  color: #374151;\n}\n\n.main-content {\n  background-color: #ffffff;\n}\n\n.navigation-panel {\n  background-color: #f8f9fa;\n}\n\n.registration-section {\n  overflow: hidden;\n}\n\n.collapsible-panel.registration-section--nav.collapsible-panel--expanded.collapsible-panel--side {\n  flex: 0 0 280px;\n  max-width: 300px;\n  min-width: 200px;\n}\n\n.registration-section--nav .registration-data-grid {\n  margin: 0;\n  border: none;\n  border-radius: 0;\n  box-shadow: none;\n  padding: 4px;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n.main-images {\n  display: grid;\n  grid-template-columns: 2fr 2fr;\n}\n\n.hidden {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
